import React from 'react';

export interface InfoModalConfig {
  title: string;
  content: React.ReactElement | string;
}

export type InfoModalContextType = {
  current: InfoModalConfig | undefined;
  showInfoModal: (title: string, content: React.ReactElement | string) => void;
  clearInfoModal: () => void;
};

export const InfoModalContext = React.createContext<InfoModalContextType | undefined>(undefined);
